var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"service"}},[_c('transition',{attrs:{"name":"slide","mode":"out-in","appear":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }